import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { InlinePdf } from '../components/cursos/ProtectedMedia';
import { ChevronLeft, FileText, BookOpen, Newspaper, MonitorPlay, Printer, Home } from 'lucide-react';
import { DOCUMENTOS_GUIAS } from '../data/guiasDocumentos';
import '../styles/landing.css';

const DOCUMENTOS = DOCUMENTOS_GUIAS;

const ICONOS = {
  'guia-sustentante': <BookOpen size={20} style={{ color: '#c5a059' }} />,
  'folleto': <Newspaper size={20} style={{ color: '#f87171' }} />,
  'guia-desde-casa': <Home size={20} style={{ color: '#38bdf8' }} />,
  'modalidad-linea': <MonitorPlay size={20} style={{ color: '#34d399' }} />,
  'modalidad-impresa': <Printer size={20} style={{ color: '#a78bfa' }} />,
};

export default function GuiasPage() {
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const docId = searchParams.get('doc');
    if (!docId) return;
    const found = DOCUMENTOS.find((d) => d.id === docId);
    if (found) setSelected(found);
  }, [searchParams]);

  const openDoc = (doc) => {
    setSelected(doc);
    navigate(`/guias?doc=${doc.id}`);
    if (typeof window !== 'undefined') window.scrollTo({ top: 0 });
  };

  const closeReader = () => {
    setSelected(null);
    navigate('/guias');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg-primary)' }}>
      <Header />
      <main className="container" style={{ flex: 1, width: '100%', maxWidth: 'none', display: 'flex', flexDirection: 'column', paddingTop: selected ? '10px' : 'var(--spacing-2xl)', paddingBottom: selected ? '10px' : 'var(--spacing-2xl)' }}>
        {/* Encabezado */}
        {!selected && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '22px',
          paddingBottom: '16px', borderBottom: '1px solid rgba(197,160,89,0.2)', flexWrap: 'wrap',
        }}>
          <div style={{
            width: '46px', height: '46px', borderRadius: '12px', flexShrink: 0,
            background: 'rgba(197,160,89,0.12)', border: '1px solid rgba(197,160,89,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <FileText size={22} style={{ color: '#c5a059' }} />
          </div>
          <div style={{ flex: 1, minWidth: '220px' }}>
            <h2 style={{
              margin: '0', fontFamily: "'Orbitron', sans-serif", fontSize: '0.95rem',
              fontWeight: 700, color: '#c5a059', letterSpacing: '1.5px', textTransform: 'uppercase',
            }}>
              Guías Oficiales CENEVAL · EXANI-II
            </h2>
            <span style={{ fontSize: '0.72rem', color: 'rgba(181,200,216,0.65)' }}>
              Acceso libre y gratuito · Solo lectura (sin descarga)
            </span>
          </div>
          <span style={{
            fontSize: '0.62rem', fontFamily: "'Orbitron', sans-serif", letterSpacing: '1px',
            color: '#c5a059', background: 'rgba(197,160,89,0.1)', border: '1px solid rgba(197,160,89,0.25)',
            padding: '5px 10px', borderRadius: '20px', textTransform: 'uppercase',
          }}>
            © CENEVAL
          </span>
        </div>
        )}

        {!selected ? (
          <>
            <p style={{ fontSize: '0.82rem', color: 'rgba(181,200,216,0.7)', lineHeight: 1.7, margin: '0 0 20px' }}>
              Material oficial del Centro Nacional de Evaluación para la Educación Superior. Selecciona un
              documento para consultarlo en pantalla. Los archivos se muestran <strong style={{ color: '#c5a059' }}>solo lectura</strong>:
              sin botón de descarga ni enlace directo al archivo.
            </p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {DOCUMENTOS.map((doc) => (
                <button
                  key={doc.id}
                  type="button"
                  onClick={() => openDoc(doc)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '14px', textAlign: 'left', cursor: 'pointer',
                    background: 'rgba(10,26,42,0.75)', border: '1px solid rgba(197,160,89,0.18)',
                    borderLeft: '3px solid rgba(197,160,89,0.55)', borderRadius: '10px',
                    padding: '14px 16px', transition: 'all 0.25s ease', width: '100%',
                    fontFamily: "'Inter', sans-serif", color: '#e2e8f0',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(197,160,89,0.5)';
                    e.currentTarget.style.background = 'rgba(13,32,53,0.9)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(197,160,89,0.18)';
                    e.currentTarget.style.background = 'rgba(10,26,42,0.75)';
                  }}
                >
                  <div style={{
                    width: '40px', height: '40px', borderRadius: '10px', flexShrink: 0,
                    background: 'rgba(7,21,38,0.7)', border: '1px solid rgba(197,160,89,0.15)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    {ICONOS[doc.id]}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: '0.88rem', fontWeight: 700, color: '#f1f5f9' }}>{doc.title}</span>
                    </div>
                    <p style={{ margin: '4px 0 0', fontSize: '0.76rem', color: 'rgba(181,200,216,0.7)', lineHeight: 1.5 }}>
                      {doc.desc}
                    </p>
                    <span style={{ fontSize: '0.64rem', color: '#64748b', marginTop: '3px', display: 'block' }}>
                      Actualizado: {doc.date}
                    </span>
                  </div>
                  <span style={{
                    flexShrink: 0, fontSize: '0.62rem', fontWeight: 700, letterSpacing: '1px',
                    textTransform: 'uppercase', color: '#c5a059', border: '1px solid rgba(197,160,89,0.35)',
                    padding: '6px 12px', borderRadius: '20px', background: 'rgba(197,160,89,0.08)',
                    fontFamily: "'Orbitron', sans-serif",
                  }}>
                    Leer PDF
                  </span>
                </button>
              ))}
            </div>

            <div className="section-cta" style={{ marginTop: 'var(--spacing-3xl)' }}>
              <LinkToHome navigate={navigate} />
            </div>
          </>
        ) : (
          <div className="guias-reader-wrap">
            <div className="guias-reader-toolbar" style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px', flexWrap: 'wrap' }}>
              <button
                type="button"
                onClick={closeReader}
                style={{
                  display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer',
                  background: 'rgba(197,160,89,0.1)', border: '1px solid rgba(197,160,89,0.3)',
                  borderRadius: '8px', color: '#c5a059', fontSize: '0.7rem', fontWeight: 700,
                  padding: '8px 14px', fontFamily: "'Orbitron', sans-serif", letterSpacing: '1px',
                  textTransform: 'uppercase',
                }}
              >
                <ChevronLeft size={14} /> Todas las guías
              </button>
              <div style={{ flex: 1, minWidth: '200px' }}>
                <span style={{ display: 'block', fontSize: '0.88rem', fontWeight: 700, color: '#f1f5f9' }}>
                  {selected.title}
                </span>
                <span style={{ fontSize: '0.66rem', color: '#64748b' }}>
                  Documento oficial · Solo lectura · CENEVAL
                </span>
              </div>
            </div>
            <InlinePdf url={selected.url} name={selected.title} book />
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}

function LinkToHome({ navigate }) {
  return (
    <button
      type="button"
      onClick={() => navigate('/')}
      style={{
        background: 'rgba(197,160,89,0.1)', border: '1px solid rgba(197,160,89,0.3)', cursor: 'pointer',
        color: '#c5a059', fontFamily: "'Orbitron', sans-serif", fontSize: '0.7rem', fontWeight: 700,
        letterSpacing: '1px', textTransform: 'uppercase', padding: '12px 26px', borderRadius: '8px',
      }}
    >
      ← Volver al inicio
    </button>
  );
}